var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 2.25H7.4375L5.93359 0.773438C5.76953 0.609375 5.55078 0.5 5.30469 0.5H1.3125C0.574219 0.5 0 1.10156 0 1.8125V9.6875C0 10.4258 0.574219 11 1.3125 11H12.6875C13.3984 11 14 10.4258 14 9.6875V3.5625C14 2.85156 13.3984 2.25 12.6875 2.25ZM12.6875 9.6875H1.3125V1.8125H5.14062L6.61719 3.31641C6.78125 3.48047 7 3.5625 7.24609 3.5625H12.6875V9.6875Z",
    fill: "#276EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSelected);
export default __webpack_public_path__ + "static/media/folder-selected.d673a4d7fcca6ff68bf1e9a753d48bba.svg";
export { ForwardRef as ReactComponent };